export const FETCH_OPTIONS = "FETCH_OPTIONS";
export const FETCH_BACKUPS = "FETCH_BACKUPS";
export const FETCH_LOGS = "FETCH_LOGS";
export const CLEAR_BACKUPS = "CLEAR_BACKUPS";
export const EDIT_OPTIONS_INFO = "EDIT_OPTIONS_INFO";